import React, { useState } from 'react';
import { Stack } from '@mui/material';
import DropdownMenu from './DropdownMenu';
import NavTitle from './NavTitle';

const MainNavLinks = ({ navs }) => {
  const [selectedNav, setSelectedNav] = useState(null);

  const handleClick = (e, nav) => {
    e.preventDefault();
    if (selectedNav && selectedNav.title === nav.title) {
      setSelectedNav(null);
    } else {
      setSelectedNav(nav);
    }
  };
  const handleClose = () => {
    setSelectedNav(null);
  };

  return (
    <Stack direction='row' justifyContent='space-between'>
      {navs?.map(nav => (
        <React.Fragment key={nav.title}>
          <NavTitle nav={nav} handleClick={handleClick} handleClose={handleClose} />
          {selectedNav?.title === nav.title && (
            <DropdownMenu handleClose={handleClose} nav={selectedNav} />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default MainNavLinks;
